/**
 * Tero Starter - Theme JavaScript
 */

// CSS entry — imported here so Vite's module graph tracks SCSS dependencies.
// In production, Rollup extracts this to dist/css/style.css.
import '../css/style.css';

// Import helpers and components
import { helpers } from './theme/helpers.js';
import { headerMenu } from './theme/components/header-menu.js';
import { cards } from './theme/components/cards.js';
import { reviews } from './theme/components/reviews.js';
import { nextSection } from './theme/components/next-section.js';
import { loadMoreReviews } from './theme/components/load-more-reviews.js';

window.theme = {
    globals: {
        isTouch: typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0),
    },

    helpers: helpers,

    init: function () {
        headerMenu.init();
        cards.init();
        reviews.init();
        nextSection.init();
        loadMoreReviews.init();
    },
};

document.addEventListener('DOMContentLoaded', () => {
    window.theme.init();
});
